import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Form, Spinner, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import camelCaseRecursive from 'camelcase-keys-recursive';
import { indexCourseRequest } from '../../../requests/courses';
import CardImage from '../../../components/Utils/Cards/CardImage';
import CourseSidePanel from '../../Shared/Course/CourseSidePanel';
import CourseModalShow from '../../Shared/Course/CourseModalShow';
import './style.scss';

const CourseProfileIndex = () => {
  const [courses, setCourses] = useState([]);
  const [onRequest, setOnRequest] = useState(true);
  const [checked, setChecked] = useState(false);
  const [visibleCount, setVisibleCount] = useState(6);
  const [panelShow, setPanelShow] = useState(false);
  const [panelTitle, setPanelTitle] = useState('');
  const [panelContent, setPanelContent] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth);
  const employeeId = user.employeeCard?.id;

  const loadCourses = useCallback(() => {
    setOnRequest(true);
    indexCourseRequest({
      dispatch,
      params: {
        display_start: 0,
        display_length: 100,
        is_public: 'published',
        filter_my_courses: checked ? employeeId : []
      },
      successCallback: response => {
        setCourses(camelCaseRecursive(response.data.data));
      },
      callback: () => setOnRequest(false)
    });
  }, [dispatch, checked, employeeId]);

  useEffect(() => {
    loadCourses();
  }, [loadCourses, refresh]);

  const handleShowInfo = course => {
    setPanelTitle('Detalle de la Capacitación');
    setPanelContent(<CourseModalShow courseId={course.id} onActionSuccess={() => setRefresh(prev => !prev)} />);
    setPanelShow(true);
  };

  const handleLoadMore = () => {
    setVisibleCount(prev => Math.min(prev + 6, courses.length));
  };

  const renderContent = () => {
    if (onRequest && courses.length === 0) {
      return (
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
        </div>
      );
    }

    if (courses.length > 0) {
      return (
        <>
          <Row className="mb-3">
            <Col md={12} className="d-flex justify-content-start">
              <Form.Group onClick={() => setChecked(!checked)} className="mb-0">
                <Form.Check
                  checked={checked}
                  className="custom-checkbox"
                  label="Ver solo mis capacitaciones"
                  type="checkbox"
                  readOnly
                  custom
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            {courses.slice(0, visibleCount).map(item => (
              <Col key={item.id} xs={12} md={4} className="mb-5">
                <CardImage
                  item={item}
                  image={item.courseImage?.fileUrl}
                  showInfo={() => handleShowInfo(item)}
                  nameShow="MÁS INFO"
                  className="card-size"
                  classNameNoImage="card-size-noimage"
                  classNameDescription="box-description-height"
                />
              </Col>
            ))}
          </Row>

          {courses.length > visibleCount && (
            <Row className="justify-content-center mt-3">
              <Col xs="auto">
                <Button onClick={handleLoadMore}>Ver más</Button>
              </Col>
            </Row>
          )}
        </>
      );
    }

    return (
      <>
        <Row className="mb-3">
          <Col md={12} className="d-flex justify-content-start">
            <Form.Group onClick={() => setChecked(!checked)} className="mb-0">
              <Form.Check
                checked={checked}
                className="custom-checkbox"
                label="Ver solo mis capacitaciones"
                type="checkbox"
                readOnly
                custom
              />
            </Form.Group>
          </Col>
        </Row>
        <div className="text-center text-muted my-5">No hay capacitaciones disponibles.</div>
      </>
    );
  };

  return (
    <>
      <Row className="mt-4 mb-4">
        <Col>
          <h2 className="mb-3 mt-3">Capacitaciones</h2>
        </Col>
      </Row>

      <div className="yellow-wrapper">{renderContent()}</div>

      <CourseSidePanel
        title={panelTitle}
        show={panelShow}
        onHide={() => {
          setPanelShow(false);
          setPanelContent(null);
        }}
      >
        {panelContent}
      </CourseSidePanel>
    </>
  );
};

export default CourseProfileIndex;
